export { Component, Inject, Mixins, Model, Prop, Provide, Ref, Vue, Watch } from 'vue-property-decorator'
export const toNative = function(obj) { return obj }
